"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Label = exports.Input = exports.SelectorWrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var SelectorWrapper = _styled.default.div(function () {
  return {
    width: '100%',
    display: 'flex'
  };
});

exports.SelectorWrapper = SelectorWrapper;

var Input = _styled.default.input(function () {
  return {
    minWidth: '16px',
    height: '16px',
    marginRight: '10px'
  };
});

exports.Input = Input;

var Label = _styled.default.label();

exports.Label = Label;